// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../node_modules/css-loader/dist/cjs.js??ref--7-oneOf-1-1!../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../node_modules/postcss-loader/src/index.js??ref--7-oneOf-1-2!./assets/styles/global.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, "\n.active[data-v-7ba5bd90] {\n    background: #385F73;\n    color: #fff !important;\n}\nspan.registeredTrademark[data-v-7ba5bd90] {\n  position: relative;\n  top: -.3rem;\n  font-size: .5rem;\n  left: -0.05rem;\n}\nfooter[data-v-7ba5bd90] {\n  font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
